export const colors = {
    black: '#0E0E0E',
    white: '#FFFFFF',
    grey: '#F2F2F2',
    greyDark: '#CDCDCD',

    greenBg: '#D5F0B5',
    greenDark: '#204A4E',
    greenPrimary: '#009878',
    greenSecondary: '#3E7673',
    greenResult: '#BFDCD2',

    brightGreen: '#BBE7D3',
    blueDark: '#8DB7D2',
    blueLight: '#DDECF8',
    red: '#FFA18A',
    brightRed: '#DA606C',
    darkRed: '#D9606C',
    yellow: '#F0D35F',
    mustard: '#F8C760',
    orange: '#FF5200',
    orangeHover: '#C13F02',
    orangeLight: '#FFD06C',
    purple: '#BB9EEA',
    purpleDark: '#5D52A7',

    swipeNo: '#FEB5A1',
    swipeYes: '#73C8C8',
    swipeDefault: '#D5F0B5',

    happyGreen: '#2fa98a',
    discount: '#B2C9A3',

    lemonYellow: '#DFD880',
};
